export const IMAGES = {
  hero: "/images/hero-gen.png",
  software: "/images/software-gen.png",
  hardware: "https://images.unsplash.com/photo-1518770660439-4636190af475?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  manufacturing: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aviation: "https://images.unsplash.com/photo-1762208743487-11a4775c12f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facility: "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  avionics: "https://images.unsplash.com/photo-1784504336427-a19b7b6e3afd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spareparts: "https://images.unsplash.com/photo-1769971361854-9e0927a2d8dc?fm=jpg&q=80&w=1200&auto=format&fit=crop"
};

export const CONTACT = {
  address: "Esentepe Mah. Keskin Kalem Sk. Arya Plaza No: 17/2, 34381 Şişli / İstanbul, TÜRKİYE",
  phone: "+90 531 622 85 02",
  phoneHref: "tel:+905316228502",
  email: "info@milsissav.com",
  emailHref: "mailto:info@milsissav.com",
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Arya+Plaza+Esentepe+%C5%9Ei%C5%9Fli+%C4%B0stanbul",
  legal: "MILSIS Haberleşme Havacılık ve Savunma Sanayi Teknolojileri Ltd. Şti."
};

export const CONTENT = {
  tr: {
    nav: {
      links: [
        { id: "capabilities", label: "Yetenekler" },
        { id: "about", label: "Hakkımızda" },
        { id: "certificates", label: "Belgeler" },
        { id: "contact", label: "İletişim" }
      ],
      cta: "Teklif Al"
    },
    certificates: {
      eyebrow: "KALİTE GÜVENCESİ",
      title: "Belgelerimiz & Sertifikalarımız",
      subtitle: "Tasarım ve üretim süreçlerimiz uluslararası kalite standartlarıyla belgelenmiştir.",
      items: [
        { id: "iso9001", thumb: "/certificates/iso9001.png" },
        { id: "as9100d", thumb: "/certificates/as9100d.png" }
      ]
    },
    hero: {
      eyebrow: "HABERLEŞME · HAVACILIK · SAVUNMA TEKNOLOJİLERİ",
      lines: ["SAVUNMA VE HAVACILIK", "TEKNOLOJİLERİNDE", "MÜHENDİSLİK GÜCÜ"],
      accentLine: 1,
      sub: "MILSIS; otopilot sistemleri, gömülü yazılımlar, donanım tasarımı, hassas parça üretimi ve havacılık danışmanlığında uçtan uca mühendislik çözümleri geliştirir.",
      ctaPrimary: "Yetenekleri Keşfet",
      ctaSecondary: "İletişime Geç",
      telemetry: ["SYS STATUS: NOMINAL", "41.0670°K 29.0106°D", "İSTANBUL / TÜRKİYE"],
      scroll: "KAYDIR"
    },
    marquee: [
      "OTOPİLOT & GCS YAZILIMI",
      "PCB TASARIM",
      "5-EKSEN CNC ÜRETİM",
      "3D BASKI",
      "GÖMÜLÜ SİSTEMLER",
      "YEDEK PARÇA TEDARİK",
      "TEST & DANIŞMANLIK",
      "AR-GE PROJELERİ"
    ],
    capabilities: {
      eyebrow: "YETENEK MATRİSİ",
      title: "Dört Disiplin. Tek Çatı.",
      subtitle: "Konseptten sahaya: yazılım, donanım, üretim ve havacılık hizmetlerini tek mühendislik ekibinde birleştiriyoruz.",
      chapters: [
        {
          id: "software",
          num: "01",
          title: "Yazılım Geliştirme",
          desc: "Drone uygulamaları için otopilot sistemleri, yer kontrol istasyonu (GCS) yazılımları ve kontrol kartlarına yönelik gömülü yazılımlar geliştiriyoruz.",
          bullets: ["AI destekli otopilot sistemleri", "Yer kontrol istasyonu (GCS) yazılımı", "Kontrol kartı gömülü yazılımları", "Gerçek zamanlı uçuş kontrol algoritmaları"],
          specs: ["RTOS", "AUTOPILOT", "GCS UI", "EMBEDDED C/C++"]
        },
        {
          id: "hardware",
          num: "02",
          title: "Donanım Tasarım",
          desc: "Uçuş kritik elektronikler için çok katmanlı PCB tasarımı, otopilot kartları, servo sürücüler ve kontrol modülleri tasarlıyoruz.",
          bullets: ["Çok katmanlı PCB kart tasarımı", "Otopilot ve uçuş kontrol kartları", "Servo ve aktüatör sürücüleri", "Güç ve haberleşme kontrol modülleri"],
          specs: ["MULTI-LAYER PCB", "AUTOPILOT BOARD", "SERVO DRIVER", "EMC/EMI"]
        },
        {
          id: "manufacturing",
          num: "03",
          title: "Parça Tasarım & Üretim",
          desc: "Silah yedek parçaları ve makine parçalarını CNC tezgahlarında ve 3D yazıcılarda hassas toleranslarla üretiyoruz.",
          bullets: ["Silah yedek parça üretimi", "Makine ve ekipman parçaları", "CNC freze ve torna işleme", "3D yazıcı ile hızlı prototip ve üretim"],
          specs: ["5-AXIS CNC", "3D PRINT", "REVERSE ENG.", "PROTOTYPE"]
        },
        {
          id: "aviation",
          num: "04",
          title: "Havacılık Hizmetleri",
          desc: "Uçak yedek parça temini, test hizmetleri ve havacılık projeleri için uçtan uca danışmanlık sunuyoruz.",
          bullets: ["Uçak yedek parça tedariki", "Parça test ve doğrulama hizmetleri", "Havacılık projeleri danışmanlığı", "Ar-Ge, hibe ve patent başvuru desteği"],
          specs: ["SPARE PARTS", "TEST & EVAL", "CONSULTANCY", "R&D GRANTS"]
        }
      ]
    },
    about: {
      eyebrow: "MİL-SİS MANİFESTO",
      title: "Fikirden Sahaya Tam Hakimiyet.",
      chapters: [
        {
          num: "01",
          title: "Ar-Ge Odaklı Mühendislik",
          desc: "Haberleşme, havacılık ve savunma alanlarında özgün tasarım ve geliştirme yapıyor; her projeyi kendi ürünümüz gibi sahipleniyoruz."
        },
        {
          num: "02",
          title: "Uçtan Uca Üretim Kabiliyeti",
          desc: "Yazılımdan PCB'ye, CNC işlemeden 3D baskıya kadar tüm üretim zincirini tek çatı altında yönetiyoruz. Tedarik riskini ortadan kaldırıyoruz."
        },
        {
          num: "03",
          title: "Test, Kalite & Danışmanlık",
          desc: "Yedek parça temininden test süreçlerine, Ar-Ge proje danışmanlığından hibe ve patent başvurularına kadar her aşamada yanınızdayız."
        }
      ],
      stats: [
        { value: "04", label: "Ana Disiplin" },
        { value: "360°", label: "Uçtan Uca Çözüm" },
        { value: "İST", label: "İstanbul Merkez" },
        { value: "R&D", label: "Ar-Ge Odaklı" }
      ]
    },
    contact: {
      eyebrow: "GÖREV TALEBİ",
      title: "Projenizi Konuşalım",
      subtitle: "Formu doldurun, mühendislik ekibimiz en kısa sürede size dönüş yapsın.",
      form: {
        name: "Ad Soyad",
        email: "E-posta",
        phone: "Telefon (opsiyonel)",
        service: "İlgilendiğiniz Alan",
        message: "Mesajınız",
        submit: "Gönder",
        sending: "Gönderiliyor...",
        services: ["Yazılım Geliştirme", "Donanım Tasarım", "Parça Tasarım & Üretim", "Havacılık Hizmetleri", "Diğer"]
      },
      success: "Mesajınız alındı. En kısa sürede dönüş yapacağız.",
      error: "Gönderim başarısız. Lütfen tekrar deneyin.",
      infoTitle: "İletişim Bilgileri",
      addressLabel: "Adres",
      phoneLabel: "Telefon",
      emailLabel: "E-posta",
      mapLink: "Haritada Gör"
    },
    footer: {
      tagline: "Haberleşme, havacılık ve savunma teknolojilerinde mühendislik çözümleri.",
      rights: "Tüm hakları saklıdır.",
      backTop: "YUKARI DÖN"
    }
  },
  en: {
    nav: {
      links: [
        { id: "capabilities", label: "Capabilities" },
        { id: "about", label: "About" },
        { id: "certificates", label: "Certificates" },
        { id: "contact", label: "Contact" }
      ],
      cta: "Get a Quote"
    },
    certificates: {
      eyebrow: "QUALITY ASSURANCE",
      title: "Our Documents & Certificates",
      subtitle: "Our design and manufacturing processes are certified to international quality standards.",
      items: [
        { id: "iso9001", thumb: "/certificates/iso9001.png" },
        { id: "as9100d", thumb: "/certificates/as9100d.png" }
      ]
    },
    hero: {
      eyebrow: "COMMUNICATION · AEROSPACE · DEFENCE TECHNOLOGIES",
      lines: ["ENGINEERING POWER", "IN DEFENCE &", "AEROSPACE TECH"],
      accentLine: 0,
      sub: "MILSIS delivers end-to-end engineering solutions in autopilot systems, embedded software, hardware design, precision manufacturing and aviation consultancy.",
      ctaPrimary: "Explore Capabilities",
      ctaSecondary: "Get in Touch",
      telemetry: ["SYS STATUS: NOMINAL", "41.0670°N 29.0106°E", "ISTANBUL / TÜRKİYE"],
      scroll: "SCROLL"
    },
    marquee: [
      "AUTOPILOT & GCS SOFTWARE",
      "PCB DESIGN",
      "5-AXIS CNC MACHINING",
      "3D PRINTING",
      "EMBEDDED SYSTEMS",
      "SPARE PARTS SUPPLY",
      "TEST & CONSULTANCY",
      "R&D PROJECTS"
    ],
    capabilities: {
      eyebrow: "CAPABILITY MATRIX",
      title: "Four Disciplines. One Roof.",
      subtitle: "From concept to field: we combine software, hardware, manufacturing and aviation services in a single engineering team.",
      chapters: [
        {
          id: "software",
          num: "01",
          title: "Software Development",
          desc: "We develop autopilot systems, ground control station (GCS) software and embedded firmware for control boards in drone applications.",
          bullets: ["AI-based autopilot systems", "Ground control station (GCS) software", "Embedded firmware for control boards", "Real-time flight control algorithms"],
          specs: ["RTOS", "AUTOPILOT", "GCS UI", "EMBEDDED C/C++"]
        },
        {
          id: "hardware",
          num: "02",
          title: "Hardware Design",
          desc: "We design multi-layer PCBs, autopilot boards, servo drivers and control modules for flight-critical electronics.",
          bullets: ["Multi-layer PCB design", "Autopilot & flight control boards", "Servo and actuator drivers", "Power & communication control modules"],
          specs: ["MULTI-LAYER PCB", "AUTOPILOT BOARD", "SERVO DRIVER", "EMC/EMI"]
        },
        {
          id: "manufacturing",
          num: "03",
          title: "Part Design & Manufacturing",
          desc: "We manufacture weapon spare parts and machine components with tight tolerances on CNC machines and 3D printers.",
          bullets: ["Weapon spare part production", "Machine & equipment components", "CNC milling and turning", "Rapid prototyping & 3D printing"],
          specs: ["5-AXIS CNC", "3D PRINT", "REVERSE ENG.", "PROTOTYPE"]
        },
        {
          id: "aviation",
          num: "04",
          title: "Aviation Services",
          desc: "Aircraft spare parts supply, testing services and end-to-end consultancy for aviation projects.",
          bullets: ["Aircraft spare parts procurement", "Part testing & validation services", "Aviation project consultancy", "R&D, grant & patent application support"],
          specs: ["SPARE PARTS", "TEST & EVAL", "CONSULTANCY", "R&D GRANTS"]
        }
      ]
    },
    about: {
      eyebrow: "THE MILSIS MANIFESTO",
      title: "Engineering, From Idea to Field.",
      chapters: [
        {
          num: "01",
          title: "R&D-Driven Engineering",
          desc: "We design and develop original solutions in communication, aerospace and defence — owning every project as if it were our own product."
        },
        {
          num: "02",
          title: "End-to-End Production",
          desc: "From software to PCB, CNC machining to 3D printing, we manage the entire production chain under one roof — eliminating supply risk."
        },
        {
          num: "03",
          title: "Test, Quality & Consultancy",
          desc: "From spare parts supply to testing, R&D consultancy to grant and patent applications — we stand with you at every stage."
        }
      ],
      stats: [
        { value: "04", label: "Core Disciplines" },
        { value: "360°", label: "End-to-End Solutions" },
        { value: "IST", label: "Istanbul HQ" },
        { value: "R&D", label: "Research Driven" }
      ]
    },
    contact: {
      eyebrow: "MISSION REQUEST",
      title: "Let's Talk About Your Project",
      subtitle: "Fill in the form and our engineering team will get back to you shortly.",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone (optional)",
        service: "Area of Interest",
        message: "Your Message",
        submit: "Send",
        sending: "Sending...",
        services: ["Software Development", "Hardware Design", "Part Design & Manufacturing", "Aviation Services", "Other"]
      },
      success: "Message received. We will get back to you shortly.",
      error: "Submission failed. Please try again.",
      infoTitle: "Contact Information",
      addressLabel: "Address",
      phoneLabel: "Phone",
      emailLabel: "Email",
      mapLink: "View on Map"
    },
    footer: {
      tagline: "Engineering solutions for communication, aerospace and defence technologies.",
      rights: "All rights reserved.",
      backTop: "BACK TO TOP"
    }
  }
};

export const GATEWAY = {
  tr: {
    brand: "HABERLEŞME · HAVACILIK · SAVUNMA TEKNOLOJİLERİ",
    engineering: {
      kicker: "ENGINEERING",
      title: "MÜHENDİSLİK",
      desc: "Gömülü yazılım ve donanım geliştirme, proje danışmanlık hizmetleri"
    },
    spare: {
      kicker: "SPARE PARTS",
      title: "YEDEK PARÇA",
      desc: "Drone, uçak ve makine yedek parça"
    }
  },
  en: {
    brand: "COMMUNICATION · AEROSPACE · DEFENCE TECHNOLOGIES",
    engineering: {
      kicker: "MÜHENDİSLİK",
      title: "ENGINEERING",
      desc: "Embedded software and hardware development, project consultancy services"
    },
    spare: {
      kicker: "YEDEK PARÇA",
      title: "SPARE PARTS",
      desc: "Drone, aircraft and machinery spare parts"
    }
  }
};

export const SPAREPARTS = {
  tr: {
    back: "Geri",
    eyebrow: "YEDEK PARÇA TEDARİKİ",
    title: "Yedek Parça Temini",
    desc: "MILSIS; havacılık, elektronik ve makine alanlarında yedek parça temini sunar. İhtiyacınız olan parçayı bulur, tedarik eder ve size ulaştırır.",
    cta: "Teklif İçin Yazın",
    contactTitle: "Şirket İletişim Bilgileri",
    labels: { address: "Adres", phone: "Telefon", email: "E-posta" },
    cards: [
      {
        title: "Havacılık Yedek Parçaları",
        desc: "Uçak platformları için yedek parça tedariki, kaynak bulma ve lojistik süreçlerinin yönetimi."
      },
      {
        title: "Elektronik Yedek Parçalar",
        desc: "Elektronik kart, modül ve komponent seviyesinde yedek parça temini."
      },
      {
        title: "Makine Yedek Parçaları",
        desc: "Endüstriyel makineler için mekanik yedek parça tedariki ve üretimi."
      }
    ]
  },
  en: {
    back: "Back",
    eyebrow: "SPARE PARTS SUPPLY",
    title: "Spare Parts Supply",
    desc: "MILSIS supplies spare parts across aviation, electronics and machinery. We source, procure and deliver the parts you need.",
    cta: "Request a Quote",
    contactTitle: "Company Contact Information",
    labels: { address: "Address", phone: "Phone", email: "Email" },
    cards: [
      {
        title: "Aviation Spare Parts",
        desc: "Spare parts procurement, sourcing and logistics management for aircraft platforms."
      },
      {
        title: "Electronic Spare Parts",
        desc: "Spare parts supply at board, module and component level."
      },
      {
        title: "Machinery Spare Parts",
        desc: "Mechanical spare parts supply and production for industrial machinery."
      }
    ]
  }
};
